/* --- Best Selling Home Carousel ---------- */
    $('#best_selling').owlCarousel({
            loop:false,
            margin:0,
            nav:false,
            dots: false,
            mouseDrag: false,
            navText: [ '', '' ],
            responsive:{
                0:{
                    items:1,
                    stagePadding:0,
                    margin:10,
                    mouseDrag: true,
                    nav:true,
                },
                768:{
                    items:4,
                },
                1000:{
                    items:4
                }
            }
        });

/* --- Categories Home Carousel ---------- */
    $('#pro_categories').owlCarousel({
            loop:false,
            margin:10,
            nav:false,
            dots: false,
            mouseDrag: false,
            navText: [ '', '' ],
            responsive:{
                0:{
                    items:1,
                    stagePadding:40,
                    margin:5,
                    mouseDrag: true,
                 },
                768:{
                    items:2,
                    stagePadding:40,
                    margin:5,
                    mouseDrag: true,
                 },
                1000:{
                    items:3
                }
            }
        });

/* --- Footer and Product Filter Accordion ---------- */
    $('.collapse').on('shown.bs.collapse', function(){
    $(this).parent().find(".glyphicon-plus").removeClass("glyphicon-plus").addClass("glyphicon-minus");
    }).on('hidden.bs.collapse', function(){
    $(this).parent().find(".glyphicon-minus").removeClass("glyphicon-minus").addClass("glyphicon-plus");
    });

/* --- Header Search for Mobile and Tablet ---------- */
    $(document).ready(function(){
        $("#flip").click(function(){
            $("#panel").slideToggle("slow");
        });
    });

/* --- Main Menu for Mobile and Tablet ---------- */
$(document).ready(function () {
  var trigger = $('.hamburger'),
    overlay = $('.overlay'),
    isClosed = false;

    trigger.click(function () {
      hamburger_cross();
    });

    function hamburger_cross() {

      if (isClosed == true) {
        overlay.hide();
        trigger.removeClass('is-open');
        trigger.addClass('is-closed');
        isClosed = false;
      } else {
        overlay.show();
        trigger.removeClass('is-closed');
        trigger.addClass('is-open');
        isClosed = true;
      }
  }

  $('[data-toggle="offcanvas"]').click(function () {
    $('#wrapper').toggleClass('toggled');
  });
});
/* --------------- */
/*
 * object.watch polyfill
 *
 * 2012-04-03
 *
 * By Eli Grey, http://eligrey.com
 * Public Domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

// object.watch
if (!Object.prototype.watch) {
	Object.defineProperty(Object.prototype, "watch", {
		  enumerable: false
		, configurable: true
		, writable: false
		, value: function (prop, handler) {
			var
			  oldval = this[prop]
			, newval = oldval
			, getter = function () {
				return newval;
			}
			, setter = function (val) {
				oldval = newval;
				return newval = handler.call(this, prop, oldval, val);
			}
			;
			
			if (delete this[prop]) { // can't watch constants
				Object.defineProperty(this, prop, {
					  get: getter
					, set: setter
					, enumerable: true
					, configurable: true
				});
			}
		}
	});
}

// object.unwatch
if (!Object.prototype.unwatch) {
	Object.defineProperty(Object.prototype, "unwatch", {
		  enumerable: false
		, configurable: true
		, writable: false
		, value: function (prop) {
			var val = this[prop];
			delete this[prop]; // remove accessors
			this[prop] = val;
		}
	});
}
